// @flow
const PHONE_URL_PROTOCOL = 'tel';

export { PHONE_URL_PROTOCOL };
